import ChevronRight from "@mui/icons-material/ChevronRight";
import { IconButton } from "@mui/material";
import React from "react";
import { useTranslator } from "../i18n/translator";

interface DetailButtonProps {
  onDetailClick: () => void;
}

const DetailButton = ({ onDetailClick }: DetailButtonProps) => {
  const translate = useTranslator();
  return (
    <IconButton
      size="small"
      onClick={onDetailClick}
      aria-label={translate("showDetails")}
    >
      <ChevronRight />
    </IconButton>
  );
};

export const MemoDetailButton = React.memo(DetailButton);
